/**
 * Client action types
 */
export const ClientType = {
  SELECT_CLIENT: 'SELECT_CLIENT',
  FETCH_CLIENTS_REQUEST: 'FETCH_CLIENTS_REQUEST',
  FETCH_CLIENTS_SUCCESS: 'FETCH_CLIENTS_SUCCESS',
  FETCH_CLIENTS_FAILURE: 'FETCH_CLIENTS_FAILURE',
}